import { EntityBase } from './EntityBase';

import { Validator } from 'breeze-client';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class SurveyWhoUsedMostMaterial extends EntityBase {

   /// <code> Place custom code between <code> tags
   
   /// </code>

   // Generated code. Do not place code below this line.
   id: number;
   surveyYear: string;
   displayCAS: string;
   materialId: number;
   organizationName: string;
   materialUseKgs: number;
   useOrder: number;
}

